<script setup>
import Connexion from "@/containers/connexion";
import { useAuthStore } from "@/store/auth";
import { useContextStore } from "@/store/context";

definePageMeta({
  middleware: "unauthenticated"
});

const { isLogged } = storeToRefs(useAuthStore());
const { fromUrl } = storeToRefs(useContextStore());
const { resetConnexionCallback } = useAuthStore();
const router = useRouter();

const connected = async (needReloadPage) => {
  if (fromUrl.value) {
    await navigateTo(fromUrl.value, { replace: true });
  }
  if (needReloadPage) {
    router.go();
  }
};

onBeforeRouteLeave((to, from, next) => {
  if (!isLogged.value) {
    resetConnexionCallback();
  }
  next();
});
</script>

<template>
  <div class="u-full-height u-bgcolor-white">
    <Connexion
      :popin="false"
      class="u-pt-md"
      @connected="connected"
    />
  </div>
</template>
